import axios, { AxiosResponse } from 'axios';
import { Resolver } from '../../config';
import { DownloadedEvidence, Evidence } from '../../common/types';

const buildEvidencePayload = (evidenceData: Uint8Array, evidence: Evidence): DownloadedEvidence => {
  return {
    content: evidence.content,
    'content-type': evidence['content-type'],
    sha256: evidence.sha256,
    evidenceData,
  };
};

export default class EvidenceService {
  private defaultRetries: number;

  private cache: Record<string, Promise<AxiosResponse<Buffer>>>;

  private static instance: EvidenceService;

  constructor() {
    const serviceConfig = Resolver.getServiceConfig();
    this.cache = {};
    this.defaultRetries = serviceConfig.networkRetryConfig.defaultRetries;
  }

  public static getInstance() {
    if (!EvidenceService.instance) {
      EvidenceService.instance = new EvidenceService();
    }
    return EvidenceService.instance;
  }

  async downloadEvidence(evidence: Evidence) {
    let evidenceBuffer = evidence.blob;

    if (evidence.downloadUrl) {
      if (!this.cache[evidence.sha256]) {
        this.cache[evidence.sha256] = axios.request({
          method: 'GET',
          responseType: 'arraybuffer',
          url: evidence.downloadUrl,
          retryConfig: {
            retries: this.defaultRetries,
          },
        });
      }
      const evidenceImg = await this.cache[evidence.sha256];
      evidenceBuffer = new Uint8Array(evidenceImg.data);
    }

    if (!evidenceBuffer) {
      throw new Error('Evidence not found');
    }
    return buildEvidencePayload(evidenceBuffer, evidence);
  }
}
